import React from 'react';
import Typography from '@mui/material/Typography';
import renderHTML from 'html-react-parser';
import { Helmet } from 'react-helmet';

export default class PrivacyPolicyPage extends React.Component {

  render() {
    const { promotion, content } = this.props;

    return (
      <React.Fragment>
        <Helmet>
          <title>{promotion.name} | Privacy Policy</title>
        </Helmet>

        <Typography variant="h4" align="center">
          Privacy Policy
        </Typography>

        <Typography variant="subtitle1" className="custom-tab-content">
          {content && renderHTML(content)}
        </Typography>
      </React.Fragment>
    )
  }
}
